import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-back",
  "use": "arrow-back-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"arrow-back\"><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.28.47a.75.75 0 010 1.06L2.06 4.75l3.22 3.22a.75.75 0 01-1.06 1.06L.47 5.28a.75.75 0 010-1.06L4.22.47a.75.75 0 011.06 0z\" /><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.25 4.75A.75.75 0 011 4h9a3.75 3.75 0 013.75 3.75V13a.75.75 0 01-1.5 0V7.75A2.25 2.25 0 0010 5.5H1a.75.75 0 01-.75-.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol